<template>
	<card layout="table" tag="section">
		<template #default>
			<div class="b-table" v-if="!loading">
				<o-table
					:data="list"
					:defaultSort="['Id', 'desc']"
					:per-page="perPage"
					:paginated="!!perPage && list.length > perPage"
					pagination-simple
					:rowClass="(row, index) => 'is-clickable'"
					@click="Goto">
					<o-table-column field="Id" label="" v-slot="props">
						<user-picture :user="props.row" size="micro"></user-picture>
					</o-table-column>
					<o-table-column field="firstName" label="First" v-slot="props" sortable>
						{{ props.row.firstName }}
					</o-table-column>
					<o-table-column field="lastName" label="Last" v-slot="props" sortable>
						{{ props.row.lastName }}
					</o-table-column>
					<o-table-column field="title" label="Title" v-slot="props" sortable>
						{{ props.row.title }}
					</o-table-column>
					<o-table-column field="license" label="License" v-slot="props" sortable>
						{{ props.row.license }}
					</o-table-column>
					<o-table-column field="phone" label="Phone" v-slot="props">
						<div v-if="props.row.mobilePhone">
							<a :href="'tel:' + props.row.mobilePhone">(M) {{ props.row.mobilePhone }}</a>
						</div>
						<div v-if="props.row.officePhone">
							<a :href="'tel:' + props.row.officePhone">(O) {{ props.row.officePhone }}</a>
						</div>
					</o-table-column>
					<o-table-column field="email" label="Email" v-slot="props">
						<a :href="'mailto:' + props.row.email" v-html="FormatEmail(props.row.email)"></a>
					</o-table-column>
				</o-table>
			</div>
			<div v-else>
				<loading></loading>
			</div>
		</template>
	</card>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";

	export default {
		props: {
			adgroup: {
				type: String,
				default: undefined
			},
			sort: {
				type: String,
				default: "lastName"
			},
			sortDirection: {
				type: String,
				default: "ASC"
			},
			perPage: {
				type: Number,
				default: 0
			},
			filters: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		setup(props, context) {
			const moment = inject("$moment");
			const $http = inject("$http");

			const loading = ref(true);
			const list = ref([]);

			const GetMemberList = async () => {
				loading.value = true;

				try {
					const response = await $http.post("/api/v2/widget/memberList", {
						filter: props.filters?.keys || [],
						sort: props.sort,
						sortDirection: props.sortDirection,
						adgroup: props.adgroup
					});
					list.value = response.data;
				} catch (err) {
					console.error(err);
				}

				loading.value = false;
			};

			const FormatEmail = (email) => {
				if (!email) return "";
				const parts = email.split("@");
				return parts[0] + "<wbr>@" + parts[1];
			};

			const Goto = (row) => {
				window.open("/directory/boydenians/" + row.Id, "_blank");
			}

			onMounted(() => {
				GetMemberList();
			});

			return {
				moment,
				loading,
				list,
				FormatEmail,
                Goto
			};
		}
	};
</script>
